export const MEGA_MENU_CONFIG = {
  // Query Configuration
  QUERY_CONFIG: {
    BLOGS: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
    EVENTS: {
      staleTime: 60000, // 1 minute
      gcTime: 300000, // 5 minutes
      limit: 2,
    },
  },

  // Colors
  COLORS: {
    adviser: {
      background: 'bg-[#006EB7]',
      selected: 'menu-selected-container menu-selected-text',
    },
    customer: {
      background: 'bg-[#8D1558]',
      selected: 'text-[#F3F4F8] bg-[#A51367]',
    },
    overlay: 'bg-[#9ca3af80]',
    border: 'border-[#CBCDD6]',
  },

  // Social Media Links
  SOCIAL_LINKS: {
    LINKEDIN: 'https://www.linkedin.com/company/pure-retirement-ltd',
    YOUTUBE: {
      CUSTOMER: 'https://www.youtube.com/@pureretirementforourcustom6170/videos',
      ADVISER: 'https://www.youtube.com/channel/UCB9qhCS5ZWArD1hiZF0P48g',
    },
  },

  // Menu Types that require data fetching
  DATA_DEPENDENT_MENUS: {
    NEWS: 'News',
    EVENTS: 'Events',
  },
};

// Close Icon SVG Component
export const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.26782 4.20709C4.48007 3.99485 4.82418 3.99485 5.03642 4.20709L8.99995 8.17062L12.9635 4.20709C13.1757 3.99485 13.5198 3.99485 13.7321 4.20709C13.9443 4.41934 13.9443 4.76345 13.7321 4.97569L9.76854 8.93922L13.7321 12.9027C13.9443 13.115 13.9443 13.4591 13.7321 13.6713C13.5198 13.8836 13.1757 13.8836 12.9635 13.6713L8.99995 9.70781L5.03642 13.6713C4.82418 13.8836 4.48007 13.8836 4.26782 13.6713C4.05558 13.4591 4.05558 13.115 4.26782 12.9027L8.23135 8.93922L4.26782 4.97569C4.05558 4.76345 4.05558 4.41934 4.26782 4.20709Z"
      fill="#0C0D1A"
      stroke="#0C0D1A"
      strokeWidth="0.395257"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
